module.exports = __webpack_public_path__ + "static/undraw_hacker_mind_6y85-946f0d7e4e3d8a10f62d798a3157b6f4.svg";